import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_ServiceUsagesGroups_Reorder_Mutation =
  graphql(`
    mutation ResolvableMissionTypeForm_ServiceUsagesGroups_Reorder(
      $groups: [ResolvableServiceUsagesGroupReorganizeInput!]!
      $serviceUserId: Id!
      $versionData: VersionDataInput
    ) {
      reorganizeResolvableMissionTypeServiceUsagesGroups(
        groups: $groups
        serviceUserId: $serviceUserId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useReorderResolvableMissionTypeServiceUsagesGroupsMutation = () =>
  useGraphQLMutation(
    ResolvableMissionTypeForm_ServiceUsagesGroups_Reorder_Mutation,
  );
